import Lottie from 'lottie-react';
import { useState, useCallback } from 'react';
import FormControlLabel from '../../../../global/Mui/FormControlLabel';
import Checkbox from '../../../../global/Mui/Checkbox';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../../../global/Button';

import './ReuseBox.scss';
import virtualBoxAnimation from '../../../../animations/virtual-box.json';

const ReuseBox = ({
  onSubmit,
  stepTrackerProps,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = useCallback((event) => {
    setIsChecked(event.target.checked);
  }, []);

  return (
    <div className="ReuseBox">
      <div className="ReuseBox__container">
        <div className="ReuseBox__container--title">
          REUSE A BOX
        </div>

        <div className="ReuseBox__container--subtitle">
          Grab a box from home (Amazon boxes work great). Make sure the longest side is
          no larger than 16 inches.
        </div>

        <div className="ReuseBox__container--image">
          <div className="ReuseBox__container--image--background">
            <div
              className="ReuseBox__container--image--box"
            >
              <Lottie
                animationData={virtualBoxAnimation}
                loop
                autoplay
              />
            </div>
          </div>
        </div>

        <div className="ReuseBox__container--content">
          <div className="ReuseBox__container--content--actions">
            <FormControlLabel
              label="I agree to the following:"
              control={(
                <Checkbox
                  checkedColor="#2649D4 !important"
                  onChange={handleCheckboxChange}
                />
              )}
            />
            <div className="ReuseBox__container--content--requirements">
              <ul>
                <li>Pack items in a sturdy box.</li>
                <li>Longest side no larger than 16 inches.</li>
                <li>Max weight 10 lbs or less</li>
              </ul>
            </div>
            <Button
              type={BUTTON_TYPE.QUATERNARY}
              size={BUTTON_SIZE.LARGE}
              onClick={onSubmit}
              disabled={!isChecked}
              trackerProps={stepTrackerProps}
            >
              CONTINUE
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReuseBox;
